import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const downloadPatientCSV = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PATIENT_CSV_DOWNLOAD.METHOD](APIConfig.PATIENT_CSV_DOWNLOAD.URL, payload);
}
const downloadAllPatientCSV = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ALL_PATIENT_CSV_DOWNLOAD.METHOD](APIConfig.ALL_PATIENT_CSV_DOWNLOAD.URL, payload);
}
const getPatientDetails = (patientId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VIEW_PATIENT.METHOD](APIConfig.VIEW_PATIENT.URL(patientId), payload);
}
const getPatientInsuranceList = (patientId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PATIENT_INSURANCE_LIST.METHOD](APIConfig.PATIENT_INSURANCE_LIST.URL(patientId), payload);
}
const deletePatient = (patientId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_PATIENT.METHOD](APIConfig.DELETE_PATIENT.URL(patientId), payload);
}
const recoverPatient = (patientId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.RECOVER_PATIENT.METHOD](APIConfig.RECOVER_PATIENT.URL(patientId), payload);
}
const verifyPatientExistence = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_PATIENT_EXISTENCE.METHOD](APIConfig.VERIFY_PATIENT_EXISTENCE.URL, payload);
}

const addPatientInformation = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_PATIENT_INFORMATION.METHOD](APIConfig.ADD_PATIENT_INFORMATION.URL, payload);
}
const removePatient = (patientId: string | number) => {
    return ApiService[APIConfig.REMOVE_PATIENT.METHOD](APIConfig.REMOVE_PATIENT.URL(patientId))
}
const addPatientInsuranceDetails = (patientID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_PATIENT_INSURANCE_DETAILS.METHOD](APIConfig.ADD_PATIENT_INSURANCE_DETAILS.URL(patientID), payload, {contentType: 'multipart/form-data'});
}
const editPatientDetails = (patientID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_PATIENT.METHOD](APIConfig.EDIT_PATIENT.URL(patientID), payload);
}
const sendOTPtoPatient = (patientID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SEND_OTP_TO_PATIENT.METHOD](APIConfig.SEND_OTP_TO_PATIENT.URL(patientID), payload);
}
const verifyPhoneNumberOtp = (patientID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_PATIENT_OTP.METHOD](APIConfig.VERIFY_PATIENT_OTP.URL(patientID), payload);
}
const verifyPatientInsurance = (patientID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_PATIENT_INSURANCE.METHOD](APIConfig.VERIFY_PATIENT_INSURANCE.URL(patientID), payload);
}
const addPatientContactDetails = (patientID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UPLOAD_PATIENT_CONTACT_DETAILS.METHOD](APIConfig.UPLOAD_PATIENT_CONTACT_DETAILS.URL(patientID), payload);
}
const editPatientInsuranceDetails = (patientID: any, insuranceID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_PATIENT_INSURANCE_DETAILS.METHOD](APIConfig.EDIT_PATIENT_INSURANCE_DETAILS.URL(patientID, insuranceID), payload, {contentType: 'multipart/form-data'});
}
const getPatientLogs = (patientId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_PATIENT_ACTIVITY_LOGS.METHOD](APIConfig.GET_PATIENT_ACTIVITY_LOGS.URL(patientId), payload);
}
const bulkUploadPatient = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.BULK_UPLOAD_PATIENT.METHOD](APIConfig.BULK_UPLOAD_PATIENT.URL, payload);
}
const getBulkPatientListCount = (bulkPatientId: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_BULK_PATIENT_LIST_COUNT.METHOD](APIConfig.GET_BULK_PATIENT_LIST_COUNT.URL(bulkPatientId));
}
const getBulkPatientGeneratedCount = (bulkPatientId: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_BULK_PATIENT_GENERATED_COUNT.METHOD](APIConfig.GET_BULK_PATIENT_GENERATED_COUNT.URL(bulkPatientId));
}
const getBulkPatientDetails = (bulkPatientId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_BULK_PATIENT_ORDER_DETAILS.METHOD](APIConfig.GET_BULK_PATIENT_ORDER_DETAILS.URL(bulkPatientId), payload);
}
const generateBulkPatients = (bulkPatientId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GENERATE_BULK_PATIENT_ORDER.METHOD](APIConfig.GENERATE_BULK_PATIENT_ORDER.URL(bulkPatientId), payload);
}
const downloadBulkPatientTemplate = () => {
    // @ts-ignore
    return ApiService[APIConfig.DOWNLOAD_BULK_PATIENT_TEMPLATE.METHOD](APIConfig.DOWNLOAD_BULK_PATIENT_TEMPLATE.URL);
}
const resolveBulkPatientInsurances=(payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.RESOLVE_BULK_PATIENT_CONFLICT.METHOD](APIConfig.RESOLVE_BULK_PATIENT_CONFLICT.URL,payload);
}
const sendInvalidBulkPatientEmail=(sesssionId:string)=>{
    // @ts-ignore
    return ApiService[APIConfig.SEND_INVALID_BULK_PATIENT_EMAIL.METHOD](APIConfig.SEND_INVALID_BULK_PATIENT_EMAIL.URL(sesssionId));
}

//Clearing house insurance api
const toggleClearingHouse = (id: string | number) => {
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_CLEARING_HOUSE.METHOD](APIConfig.TOGGLE_CLEARING_HOUSE.URL(id));
}
const addClearingHouseInsurances = (payload: FormData) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_CLEARING_HOUSE_INSURANCES.METHOD](APIConfig.ADD_CLEARING_HOUSE_INSURANCES.URL, payload);
}
const downloadClearingHouseInsurances= (id: string | number) => {
    // @ts-ignore
    return ApiService[APIConfig.DOWNLOAD_CLEARING_HOUSE_INSURANCE_LIST.METHOD](APIConfig.DOWNLOAD_CLEARING_HOUSE_INSURANCE_LIST.URL(id));
}
const downloadInsuranceTemplate=()=>{
    // @ts-ignore
    return ApiService[APIConfig.DOWNLOAD_BULK_UPLOAD_INSURANCE_TEMPLATE.METHOD](APIConfig.DOWNLOAD_BULK_UPLOAD_INSURANCE_TEMPLATE.URL);
}
const addPatientAdditionalDetails = (patientID: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_PATIENT_ADDITIONAL_DETAILS.METHOD](APIConfig.ADD_PATIENT_ADDITIONAL_DETAILS.URL(patientID), payload);
}
const addPatientDrivingLicense = (patientID: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_PATIENT_DRIVING_LICENSE.METHOD](APIConfig.ADD_PATIENT_DRIVING_LICENSE.URL(patientID), payload);
}
const removePatientDrivingLicense = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.REMOVE_PATIENT_DRIVING_LICENSE.METHOD](APIConfig.REMOVE_PATIENT_DRIVING_LICENSE.URL,payload);
}
const PatientService = {
    downloadPatientCSV,
    downloadAllPatientCSV,
    getPatientDetails,
    deletePatient,
    recoverPatient,
    addPatientInformation,
    removePatient,
    addPatientInsuranceDetails,
    editPatientDetails,
    verifyPhoneNumberOtp,
    getPatientInsuranceList,
    verifyPatientExistence,
    addPatientContactDetails,
    sendOTPtoPatient,
    editPatientInsuranceDetails,
    verifyPatientInsurance,
    getPatientLogs,
    bulkUploadPatient,
    getBulkPatientListCount,
    getBulkPatientGeneratedCount,
    getBulkPatientDetails,
    generateBulkPatients,
    downloadBulkPatientTemplate,
    resolveBulkPatientInsurances,
    sendInvalidBulkPatientEmail,
    //clearing house insurance api
    toggleClearingHouse,
    addClearingHouseInsurances,
    downloadClearingHouseInsurances,
    downloadInsuranceTemplate,
    addPatientAdditionalDetails,
    addPatientDrivingLicense,
    removePatientDrivingLicense,
}
export default PatientService;
